import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

let deferred = null;
if (typeof window !== "undefined") window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; });

const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
const ios = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export default function VestaInstall() {
  const [open, setOpen] = useState(false);
  const [, tick] = useState(0);
  useEffect(() => { const f = () => tick((x) => x + 1); window.addEventListener("beforeinstallprompt", f); return () => window.removeEventListener("beforeinstallprompt", f); }, []);
  if (standalone()) return null;
  const installa = async () => { if (!deferred) return; deferred.prompt(); await deferred.userChoice; deferred = null; setOpen(false); };
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="vesta-install-btn" title="Installa l'icona VESTA"
        className="shrink-0 rounded-full border border-neutral-800 p-2 text-neutral-400 transition-colors duration-200 hover:border-[#C17F59] hover:text-[#C17F59]">
        <Download className="h-4 w-4" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md border-neutral-800 bg-neutral-950 text-white" data-testid="vesta-install-dialog">
          <DialogHeader><DialogTitle className="font-heading text-xl">Icona VESTA</DialogTitle></DialogHeader>
          <img src="/vesta-icon-192.png?v=4" alt="VESTA" className="h-16 w-16 rounded-2xl" />
          <p className="text-sm text-neutral-300">Con l'icona VESTA apri subito il focolare per parlare, senza passare dalla pagina principale.</p>
          {deferred ? (
            <button type="button" onClick={installa} data-testid="vesta-install-confirm" className="rounded-full bg-[#C17F59] px-5 py-2.5 text-sm font-bold text-black transition-opacity hover:opacity-90">Installa VESTA</button>
          ) : ios() ? (
            <p className="text-sm text-neutral-400" data-testid="vesta-install-ios">Su iPhone o iPad apri questa pagina con <b>Safari</b>, tocca <b>Condividi</b> e poi <b>«Aggiungi alla schermata Home»</b>.</p>
          ) : (
            <p className="text-sm text-neutral-400" data-testid="vesta-install-manual">Nel browser (Chrome o Edge) apri il menu <b>⋮</b> e scegli <b>«Installa pagina come app»</b> o <b>«Aggiungi alla schermata Home»</b>.</p>
          )}
          <p className="text-xs text-neutral-500">Indirizzo diretto da salvare nei preferiti: <span className="font-mono text-neutral-300" data-testid="vesta-install-link">{window.location.origin}/vesta/parla</span></p>
        </DialogContent>
      </Dialog>
    </>
  );
}
